import {GetRequestParam, urlEncode} from './tools/index'

const localHrefParams = GetRequestParam();
if (!localHrefParams.t) {
  localHrefParams.t = Date.parse(new Date());
  window.location.href = window.location.origin + '?' + urlEncode(localHrefParams);
}
